import React, { useRef } from "react";

import LoadingCenter from "./LoadingCenter";
import ProspectPagination from "./Prospect/ProspectPagination";

import { useHttp } from "../hooks/useHttp";
import { useQuery } from "@tanstack/react-query";
import { CAlert, CTable, CTableBody, CTableDataCell, CTableHead, CTableHeaderCell, CTableRow } from "@coreui/react";

//Momentjs
import moment from "moment";
import "moment/locale/pt-br";

const BidsTable = props => {
  const { id } = props;
  moment.locale();
  const page = useRef(1);
  const request = useHttp();

  // Create our number formatter currency
  var currency = new Intl.NumberFormat("pt-BR", {
    style: "currency",
    currency: "BRL",

    // These options are needed to round to whole numbers if that"s what you want.
    //minimumFractionDigits: 0, // (this suffices for whole numbers, but will print 2500.10 as $2,500.1)
    //maximumFractionDigits: 0, // (causes 2500.99 to be printed as $2,501)
  });

  const { data: bids, refetch, isLoading, isSuccess } = useQuery(["bids-table"], () => request({ url: `/users/lances/${id}?page=${page.current}`, method: "GET" }));

  if (isSuccess) {
    if (bids.data?.error) {
      return (
        <CAlert color="info">
          {bids.data?.message}
        </CAlert>
      );
    }
  }

  if (isLoading) return <LoadingCenter />;

  return (
    <div>
      <CTable hover>
        <CTableHead>
          <CTableRow>
            <CTableHeaderCell scope="col">
              <span className="text-color">Lote</span>
            </CTableHeaderCell>
            <CTableHeaderCell scope="col">
              <span className="text-color">Lance</span>
            </CTableHeaderCell>
            <CTableHeaderCell scope="col">
              <span className="text-color">Data</span>
            </CTableHeaderCell>
          </CTableRow>
        </CTableHead>
        <CTableBody>
          {bids.data?.lances.map(bid => {
            return (
              <CTableRow>
                <CTableDataCell align="top">
                  <span className="text-color">
                    {bid.NomeLote}
                  </span>
                </CTableDataCell>
                <CTableDataCell align="top">
                  <span className="text-color">
                    {currency.format(bid.ValorLance)}
                  </span>
                </CTableDataCell>
                <CTableDataCell align="top">
                  <span className="text-color">
                    {moment(bid.DataLance).format("l")}
                  </span>
                </CTableDataCell>
              </CTableRow>
            );
          })}
        </CTableBody>
      </CTable>
      <ProspectPagination customer={bids} page={page} refetch={refetch} />
    </div>
  );
}

export default BidsTable;